<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase"
        >Thêm phân công chủ nhiệm
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5" style="margin-bottom: 100px">
        <OwnClassTeacherNewForm ref="form" :defaultTeacher="defaultTeacher" :state="dialog" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import OwnClassTeacherNewForm from '@/components/basic/form/OwnClassTeacherNewForm'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import get from 'lodash-es/get'

export default {
  components: {
    OwnClassTeacherNewForm
  },
  props: {
    state: Boolean,
    teacher: Object,
    defaultTeacher: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapState('app', ['currentSchoolYear'])
  },
  methods: {
    ...mapActions('ownClassTeacher', ['updateClass']),
    async save() {
      try {
        const data = this.$refs.form.getData()
        if (!data) return

        if (this.defaultTeacher && this.defaultTeacher.id) data.teacher = this.defaultTeacher

        this.$loading.active = true
        const { classData, teacher } = data
        let headTeachers = []

        if (get(classData, 'headTeachers.length')) {
          headTeachers = JSON.parse(JSON.stringify(classData.headTeachers))
        }

        headTeachers.unshift(teacher)

        const metadata = {
          ...classData.metadata,
          [`${teacher.id}-${this.currentSchoolYear.id}`]: moment().toISOString()
        }

        const c = await this.updateClass({
          id: classData.id,
          headTeachers: headTeachers.map(x => x.id).filter(Boolean),
          metadata
        })

        this.$alert.success('Cập nhật thành công')
        this.dialog = false
        this.$emit('done', c)
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state() {
      this.dialog = true
    }
  }
}
</script>
